<template>
  <div class="central">
    <div class="info-top">
      <div class="mess-con">
        <div class="mess-text">
          <div class="top-mess">{{Centraloutcome.CenterAchievements}}</div>
          <!-- <div class="top-message">{{Centraloutcome.CenterAchievementsTxt}}</div> -->
        </div>
      </div>
      <!-- <img src="@/assets/my/head.jpg" alt="">
      <div class="top-mess">{{Centraloutcome.CenterAchievements}}</div>
      <div class="top-message">{{Centraloutcome.CenterAchievementsTxt}}</div> -->
    </div>
    <div class="info-bot" id="zxcg">
      <div class="bot-line"></div>
      <div class="bot-tit"  :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">
        {{Centraloutcome.CenterAchievements}}
        <div class="bot-bg">Central achievements</div>
      </div>
      <div class="type-box">
        <!-- <div
          class="tab"
          :class="isActive == '白皮书' ? 'active' : ''"
          @click="btnTabs('白皮书')"
        >
        {{Centraloutcome.ResearchReport}}
        </div>
        <div class="cut">|</div> -->
        <!-- <div
          class="tab"
          :class="isActive == '白皮书' ? 'active' : ''"
          @click="btnTabs('白皮书')"
        >
        {{Centraloutcome.whitepaper}}
        </div>
        <div class="cut">|</div>
        <div
          class="tab"
          :class="isActive == '蓝皮书' ? 'active' : ''"
          @click="btnTabs('蓝皮书')"
        >
        {{Centraloutcome.BlueBook}}
        </div>
        <div class="cut">|</div> -->
        <div
          class="tab"
          :class="isActive == '会议与活动' ? 'active' : ''"
          @click="btnTabs('会议与活动')"
        >
        {{Centraloutcome.MeetingsEvents}}
        </div>
        <!-- <div class="cut">|</div> -->
        <!-- <div
          class="tab"
          :class="isActive == '报告' ? 'active' : ''"
          @click="btnTabs('报告')"
        >
          报告
        </div>
        <div class="cut">|</div> -->
        <!-- <div
          class="tab"
          :class="isActive == '标准' ? 'active' : ''"
          @click="btnTabs('标准')"
        >
        {{Centraloutcome.standard}}
        </div> -->
      </div>
      <div class="cont-list" v-if="isActive == '白皮书' || isActive == '蓝皮书'">
        <div class="items" v-for="(item, index) in listData" :key="index"  @click="toNewPage(item)">
          <img :src="item.picture" alt=""/>
          <!-- <div class="title-box">
            {{ item.title }}
          </div> -->
        </div>
      </div>
      <div class="const-actvie" v-if="isActive == '会议与活动'">
        <div class="actives" v-for="(item,index) in activeData" :key="index">
            <div class="items">
                <div class="lefts"  @click="toDetail(item)">{{ $i18n.locale === 'en' ? item.english_title : item.title }}</div>
                <div class="rights">{{ $i18n.locale === 'en' ? formatDate(item.news_date) : item.news_date }}</div>
            </div>
            <div class="lines"></div>
        </div>
      </div>
      <div v-if="isActive == '标准'">
      
      </div>
      <div class="pagination">
        <div class="page-text" v-if="total>0">{{Centraloutcome.Total}} {{total}} {{Centraloutcome.cases}}</div>
        <el-pagination
          v-show="total > 0"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="sizeChange"
          :current-page="page"
          :page-size="size"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import mock from "../../../public/json/中心成果-白皮书蓝皮书.json";
import mock2 from "../../../public/json/中心成果-会议活动.json";
export default {
  data() {
    return {
      isActive: "会议与活动",
      dataWpsBlue: [],
      dataHyhd:[],
      listData: [],
      total: 100,
      page: 1, // 当前页码
      size:8, // 每页显示的条目数
      activeData:[],
      sectionId:'',
    };
  },
  watch:{
    '$route':function(vals,olds){
      // if(vals.query && vals.query.isSelect){
      //   if(vals.query.isSelect == '会议' || vals.query.isSelect == '活动'){
      //     this.isActive = '会议与活动';
      //   }else{
      //     this.isActive = vals.query.isSelect;
      //   }
      //   this.btnTabs(this.isActive);
      // }else{
      //   this.getData(this.dataHyhd);
      // }
      this.btnTabs(this.isActive);
    }
  },
  computed:{
    Centraloutcome(){
      return this.$t('Centraloutcome')
    }
  },
  mounted() {
    this.dataWpsBlue = mock["RECORDS"];
    this.dataHyhd = mock2["RECORDS"].sort((a, b) => {return b.news_date.split('-').join('') - a.news_date.split('-').join('')});
    this.initializeEventListener();
    let route = this.$route.query;
    console.log(route.isSelect, 'route.isSelect')
    
    // if(route.isSelect){
    //   if(route.isSelect == '会议' || route.isSelect == '活动'){
    //     this.isActive = '会议与活动';
    //   }else{
    //     this.isActive = route.isSelect;
    //   }
    //   this.btnTabs(this.isActive);
    // }else{
    //   this.getData(this.dataWpsBlue);
    // }
    this.btnTabs(this.isActive);
  },
  methods: {
    toDetail(item){
      const query = {
        id: item.id,
        type: item.type,
      }
      this.$router.push({ path: '/activeDetail', query })
    },
    initializeEventListener() {
      let that = this;
      this.$bus.$off("changePont");
      this.$bus.$on("changePont", (sectionId) => {
        this.sectionId = sectionId.isPont;
          this.$nextTick(() => {
            that.scrollTo(this.sectionId);
          });
      });
    },
    scrollTo(sectionId) {
      this.$nextTick(()=>{
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      })
    },
    toNewPage(item) {
      window.open(item.url, "_blank");
    },
    getData(datas) {
      let data = JSON.parse(JSON.stringify(datas));
      if(this.isActive == '会议与活动'){
        data = data;
        this.total = data.length;
        this.activeData = data.splice((this.page - 1) * this.size, this.size);
      }else if(this.isActive == '白皮书' || this.isActive == '蓝皮书'){
        // data = data.filter((item) => item.type == this.isActive);
        this.total = data.length;
        this.listData = data.splice((this.page - 1) * this.size, this.size);
      }
    },
    handleCurrentChange(page) {
      this.page = page;
      if(this.isActive == '会议与活动'){
        this.getData(this.dataHyhd);
      }else if(this.isActive == '白皮书' || this.isActive == '蓝皮书'){
        this.getData(this.dataWpsBlue)
      }
    },
    sizeChange(val) {
      this.page = 1; // 当前页码
      this.size = val;
      if(this.isActive == '会议与活动'){
        this.getData(this.dataHyhd);
      }else if(this.isActive == '白皮书' || this.isActive == '蓝皮书'){
        this.getData(this.dataWpsBlue)
      }
    },
    btnTabs(type) {
      this.isActive = type;
      this.page = 1;
      if(type == '会议与活动'){
        this.getData(this.dataHyhd);
      }else if(type == '白皮书' || type == '蓝皮书'){
        this.getData(this.dataWpsBlue)
      }else if(type == '标准'){
        this.total = 0;
      }
    },
    formatDate(inputDate) {
      const date = new Date(inputDate);
      if (isNaN(date)) {
        console.error('Invalid date format');
        return null;
      }
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    }
  },
};
</script>
<style lang="scss" scoped>
.bot-tit-en {
  font-weight: 600 !important;
}
.central {
  width: 100%;
  .info-top {
    .mess-con {
      height: 180px;
      max-width: 1200px;
      margin: 0 auto;
      background: url('@/assets/my/head.jpg') no-repeat;
      background-size: 100% 100%;
      .mess-text {
        max-width: 1200px;
        margin: 0 auto;
        text-align: left;
        padding: 0px 0 0 0;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
    div {
      font-family: Inter;
      color: #fff;
      font-weight: 500;
    }
    .top-mess {
      font-weight: 500;
      font-size: 36px;
      line-height: 36px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
    .top-message {
      font-size: 20px;
      line-height: 27px;
      margin-top: 20px;
      padding-left: 2vw;
      box-sizing: border-box;
    }
  }
  .info-bot {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 60px;
    box-sizing: border-box;
    .bot-line {
      margin: 0 auto;
      width: 84px;
      height: 4px;
      background: linear-gradient(270deg, #1d3e95 0%, #4840c2 100%);
      border-radius: 4px 4px 4px 4px;
      text-align: center;
    }
    .bot-tit {
      margin: 0 auto;
      margin-top: 22px;
      height: 40px;
      font-family: Inter;
      font-weight: 400;
      font-size: 36px;
      color: #080808;
      line-height: 40px;
      position: relative;
      .bot-bg {
        height: 50px;
        font-family: Inter;
        font-weight: 700;
        font-size: 36px;
        color: rgba(194, 194, 194, 0.12);
        line-height: 50px;
        text-align: center;
        position: absolute;
        top: 5px;
        left: 50%;
        transform: translate(-50%, 0);
        white-space: nowrap;
      }
    }
    .type-box {
      display: flex;
      align-items: center;
      color: #333640;
      height: 50px;
      cursor: pointer;
      margin: 30px 0px 10px 0px;
      > div {
        margin: 0px 20px;
        height: 100%;
        display: flex;
        align-items: center;
      }
      .active {
        border-bottom: 1px #1b3e92 solid;
        color: #1b3e92;
      }
      .tab {
        font-size: 18px;
        font-weight: 600;
      }
      .cut {
        color: #cccccc;
      }
      .tab:first-child {
        margin-left: 0px;
      }
    }
    .cont-list {
      display: flex;
      flex-wrap: wrap;
      .items {
        width: calc(25% - 18px);
        height: auto;
        margin-right: 24px;
        box-shadow: 0px 4px 20px 5px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        margin-bottom: 40px;
        cursor: pointer;
        &:nth-child(4n) {
          margin-right: 0px;
        }
        img {
          width: 100%;
          height: auto;
        }
        .title-box {
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          border-top: 1px solid #d8d8d8;
          box-sizing: border-box;
          font-size:14px;
        }
      }
    }
    .const-actvie{
        // padding: 0 2vw;
        box-sizing: border-box;
        padding-top: 50px;
        .actives{
            .items{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .lefts{
                    text-align: left;
                    font-family: Inter;
                    font-weight: 500;
                    font-size: 18px;
                    color: #333640;
                    cursor: pointer;
                }
                .rights{
                    font-family: D-DIN, D-DIN;
                    font-weight: 400;
                    font-size: 16px;
                    color: #61656C;
                    min-width: 200px;
                }
            }
            .lines{
                width: 100%;
                height: 1px;
                background: #D8D8D8;
                margin: 40px 0px;
            }
        }
    }
    .pagination {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 100px;
      .page-text {
        font-size: 18px;
        color: #666666;
      }
    }
  }
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #1b3e92;
  color: #fff;
}
@media (max-width: 600px) {
  .info-top {
    .top-mess {
      top: -16% !important;
      left: 15% !important;
      font-size: 20px !important;
    }
    .top-message {
      // top: 40% !important;
      left: 15% !important;
      margin-top: 0px !important;
      font-size: 14px !important;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .el-form {
    white-space: normal !important;
    text-align: left;
    &>div {
      margin-top: 8px;
    }
  }
  .left-btn > div {
    margin-right: 10px !important;
  }
  .trend-input {
    display: unset !important;
  }
  .page-text {
    width: 100px !important;
  }
  .content-photo {
    display: none !important;
  }
  .tab {
    font-size: 14px !important;
    margin: 0 2px !important;
  }
  .file-items {
    &>div {
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .time {
    min-width: 100px;
  }
  .title-box {
    display: -webkit-box !important;
    height: auto !important;
    -webkit-line-clamp: 3; //显示最大行数
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .lefts {
    display: -webkit-box !important;
    -webkit-line-clamp: 1; //显示最大行数
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
  }
  .rights {
    min-width: 200px;
  }
  .bot-bg {
    font-size: 30px !important;
  }
  .const-actvie {
    box-sizing: border-box;
    padding: 0 20px !important;
    .actives {
      height: 70px !important;
      .items {
        display: inherit !important;
        .lefts {
          font-size: 16px !important;
        }
        .rights {
          text-align: right;
          margin-top: 4px;
          font-size: 14px !important;
        }
      }
      .lines {
        margin: 8px 0 !important;
        height: 0.5px !important;
        background: #eee !important;
      }
    }
  }
  .pagination {
    flex-direction: column;
    align-items: flex-end !important;
    .page-text {
      margin-bottom: 10px;
    }
  }
  .type-box {
    padding-left: 10px;
    box-sizing: border-box;
    .cut {
      margin: 0px 10px !important;
    }
  }
  .mess-con {
    height: 150px !important;
    padding: 0 2vw;
    box-sizing: border-box;
  }
}
</style>
